var identity = function identity(x) {
  return x;
};

export default identity;